import FormAnalytics from '../formAnalytics/formAnalytics'
import { FormNames } from '../formAnalytics/formEvents.types'
import { PortalProducts } from '../types/analytics.type'

class RegisterAnalytics extends FormAnalytics {
  public constructor() {
    super(PortalProducts.ACCOUNT, FormNames.REGISTER)
  }
}

const registerAnalytics = new RegisterAnalytics()

export default registerAnalytics
